import { render, staticRenderFns } from "./topText.vue?vue&type=template&id=48fa758d&scoped=true&"
import script from "./topText.vue?vue&type=script&lang=js&"
export * from "./topText.vue?vue&type=script&lang=js&"
import style0 from "./topText.vue?vue&type=style&index=0&id=48fa758d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa758d",
  null
  
)

export default component.exports